import React from 'react';
import PropTypes from 'prop-types';

export default function UserCard({
  avatar, name, position, userRole, startWorkDate, className,
}) {
  return (
    <div className={`user-profile-card mt-3 ${className}`}>
      {avatar && <img src={avatar} alt="avatar" className="avatar" />}
      {userRole && <div className="role">{userRole}</div>}
      {startWorkDate}

      <div className="name text-truncate">
        {name}
      </div>
      <div className="title text-truncate">
        {position}
      </div>
    </div>
  );
}

UserCard.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.string,
  className: PropTypes.string,
  userRole: PropTypes.string,
  startWorkDate: PropTypes.node,
};

UserCard.defaultProps = {
  avatar: null,
  userRole: null,
  startWorkDate: null,
  name: '',
  position: '',
  className: '',
};
